module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "text-center jopa"
  }, [_c('b', [_vm._v(" Total: ")]), _vm._v(" " + _vm._s(_vm.total) + "\n  ")]), _vm._v(" "), _c('br'), _c('br'), _c('br'), _c('br')])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row text-center"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('h1', [_vm._v("Stat")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0f79d5ab"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/statistics.vue
// module id = 47
// module chunks = 0